import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './http/auth.interceptor';
import { TranslateModule, provideTranslateLoader } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';

const translateHttpLoaderConfig = {
  prefix: './assets/i18n/',
  suffix: '.json',
};

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      fallbackLang: 'pl',
      loader: provideTranslateLoader(TranslateHttpLoader),
    }),
  ],
  providers: [
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: translateHttpLoaderConfig },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
